"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Integer = void 0;
var uom_1 = require("uom");
// Discrete
// export const Integer = _register(Unit.createProductUnit<q.Discrete>("Discrete", []), " ");
exports.Integer = uom_1.Unit.createBase("Integer", "Discrete", " ");
//# sourceMappingURL=discrete.js.map